document.addEventListener("DOMContentLoaded", function () {
  
   function openGroupsIfMobile() {
  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  if (isMobile) {
    const groups = document.querySelectorAll(".header-sidebar__linklist .group");

    groups.forEach(group => {
      group.setAttribute("aria-expanded", "true");
      group.setAttribute("open", "true");
    });
  }
}

// Run once on page load
document.addEventListener("DOMContentLoaded", openGroupsIfMobile);

// Also run whenever menu opens
const menuToggle = document.querySelector(".header__primary-nav button");
if (menuToggle) {
  menuToggle.addEventListener("click", () => {
    // You might want to check if menu is opening or closing here
    // For simplicity, just run it every click (or you can add logic)
    openGroupsIfMobile();
  });
}

  });



 document.addEventListener("DOMContentLoaded", function () {
    const items = document.querySelectorAll(".product-info__block-item");

    items.forEach((item) => {
      item.addEventListener("click", function () {
        // Agar clicked item already active hai, to remove kar do
        if (this.classList.contains("active")) {
          this.classList.remove("active");
        } else {
          // Sab items se active hatao
          items.forEach((el) => el.classList.remove("active"));
          // Aur is clicked item ko active banao
          this.classList.add("active");
        }
      });
    });
  });
